import { Divider, Grid, Icon, Tooltip, Typography } from "@material-ui/core";
import { useMemo } from "react";

import datetimeHelper from "../../helper/datetime-helper";

const AgentDashboardHeader = ({ agentReport, reportInbound, styles }) => {
  const inboundData = useMemo(
    () => agentReport.find((item) => !!item.inbound)?.inbound,
    [agentReport]
  );

  return (
    <>
      <Grid container>
        <Grid
          className={styles.center}
          style={{
            borderRight: "1px solid rgba(0, 0, 0, 0.12)",
            textAlign: "center",
            padding: "0 3px",
          }}
          item
          sm={2}>
          <span className={styles.textTitle}>Contact Center</span>
        </Grid>
        <Tooltip title="Tổng số cuộc gọi đã trả lời">
          <Grid
            className={styles.center}
            item
            sm={1}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon
                className={styles.icon}
                style={{
                  color: "#015290",
                }}>
                phone_in_talk
              </Icon>
              {reportInbound && (reportInbound[0]?.answeredCalls || 0)}
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Tổng số cuộc gọi nhỡ">
          <Grid
            className={styles.center}
            item
            sm={1}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon
                className={styles.icon}
                style={{
                  color: "#fcb71e",
                }}>
                phone_missedCalls
              </Icon>
              {reportInbound && (reportInbound[0]?.missedCalls || 0)}
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Tỉ lệ nhỡ">
          <Grid className={styles.center} item sm={1}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon style={{ color: "red" }} className={styles.icon}>
                clear
              </Icon>{" "}
              {reportInbound &&
              reportInbound[0]?.missedCalls &&
              reportInbound[0]?.answeredCalls
                ? `${(
                    (reportInbound[0]?.missedCalls * 100) /
                    (reportInbound[0]?.missedCalls +
                      reportInbound[0]?.answeredCalls)
                  ).toFixed(2)}%`
                : "0.00%"}
            </Typography>
          </Grid>
        </Tooltip>
      </Grid>
      <Divider />
      <Grid container>
        <Grid
          className={styles.center}
          style={{
            borderRight: "1px solid rgba(0, 0, 0, 0.12)",
            padding: "0 3px",
          }}
          item
          sm={2}>
          <span className={styles.textTitle}>Agent</span>
        </Grid>
        <Tooltip title="Tổng số cuộc gọi đã trả lời">
          <Grid
            className={styles.center}
            item
            sm={1}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon style={{ color: "#43a047" }} className={styles.icon}>
                phone
              </Icon>
              {inboundData?.answeredCalls || 0}
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Tổng số cuộc gọi nhỡ">
          <Grid
            className={styles.center}
            item
            sm={1}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon style={{ color: "red" }} className={styles.icon}>
                phone_missed
              </Icon>{" "}
              {inboundData?.missedCall || 0}
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Tỉ lệ nhỡ">
          <Grid
            className={styles.center}
            item
            sm={1}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon style={{ color: "red" }} className={styles.icon}>
                clear
              </Icon>{" "}
              {inboundData?.msr?.toFixed(2) || "0.00"}%
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Thời gian sẵn sàng">
          <Grid
            className={styles.center}
            item
            sm={2}
            style={{ padding: "0 3px" }}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              <Icon className={styles.icon}>access_time</Icon> 00:00:00
            </Typography>
          </Grid>
        </Tooltip>
        <Tooltip title="Thời lượng trung bình các cuộc gọi">
          <Grid className={styles.center} item sm={2}>
            <Typography className={`${styles.textTitle} ${styles.center}`}>
              ACD: {datetimeHelper.secondToHHMMSS(inboundData?.acd)}
            </Typography>
          </Grid>
        </Tooltip>
      </Grid>
    </>
  );
};

export default AgentDashboardHeader;
